export const ROUTE_TRAIL_LENGTH = 0.35;

const TRAVEL_DURATION_MS = 3200;
const PAUSE_DURATION_MS = 900;
const CYCLE_DURATION_MS = TRAVEL_DURATION_MS + PAUSE_DURATION_MS;
const COMPLETED_TIME = 1 + ROUTE_TRAIL_LENGTH;

export interface RouteAnimationFrame {
  currentTime: number;
  headFraction: number | null;
  arrivalProgress: number | null;
}

export function getRouteAnimationFrame(elapsedMs: number): RouteAnimationFrame {
  const cycleElapsedMs = elapsedMs % CYCLE_DURATION_MS;

  if (cycleElapsedMs >= TRAVEL_DURATION_MS) {
    return { currentTime: COMPLETED_TIME, headFraction: null, arrivalProgress: null };
  }

  const currentTime = easeInOutSine(cycleElapsedMs / TRAVEL_DURATION_MS) * COMPLETED_TIME;

  return {
    currentTime,
    headFraction: currentTime < 1 ? currentTime : null,
    arrivalProgress: currentTime >= 1 ? (currentTime - 1) / ROUTE_TRAIL_LENGTH : null,
  };
}

function easeInOutSine(progress: number): number {
  return (1 - Math.cos(Math.PI * progress)) / 2;
}
